// ===============================================
// THIS IS A GENERATED FILE - Do NOT edit manually
//
// @see libs/data-access/generator/README.md
//
// ===============================================

import { EndpointParams as GetNotificationsEndpointParams } from '../api/getNotifications';

const baseKey = 'notifications';

export const notificationsKeys = {
  notificationUnreadCounts: () => [baseKey, 'notificationUnreadCounts'],
  notifications: ({
    pageSize,
    page,
    limit,
    cursor,
    pagingEnabled,
    module,
    excludeModules,
  }: {
    pageSize?: GetNotificationsEndpointParams['pageSize'];
    page?: GetNotificationsEndpointParams['page'];
    limit?: GetNotificationsEndpointParams['limit'];
    cursor?: GetNotificationsEndpointParams['cursor'];
    pagingEnabled?: GetNotificationsEndpointParams['pagingEnabled'];
    module?: GetNotificationsEndpointParams['module'];
    excludeModules?: GetNotificationsEndpointParams['excludeModules'];
  }) => [
    baseKey,
    'notifications',
    { pageSize, page, limit, cursor, pagingEnabled, module, excludeModules },
  ],
  getNotificationsStream: () => [baseKey, 'getNotificationsStream'],
};
